// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3tr-_","log":"ModalInventoryLogs_log__1utvq","date":"ModalInventoryLogs_date__FohSC","userName":"ModalInventoryLogs_userName__Oms7Z"};